import { render, staticRenderFns } from "./footer_tpl.vue?vue&type=template&id=e62f95a6&scoped=true&"
import script from "./footer_tpl.vue?vue&type=script&lang=js&"
export * from "./footer_tpl.vue?vue&type=script&lang=js&"
import style0 from "./footer_tpl.vue?vue&type=style&index=0&id=e62f95a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62f95a6",
  null
  
)

export default component.exports